import React from 'react';
import { IndexRedirect, Route } from '@americanexpress/one-app-router';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <Route key="/" path="/">
    <IndexRedirect to="/en-us/corporate/dashboard" />
  </Route>,
  <ModuleRoute key="recipient" moduleName="virtual-cards-recipient-journey-wrapper" />,
];

export default childRoutes;
